import { useEffect, useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { get } from '../lib/api'
import type { AdminUser } from '../lib/types'
import { AdminShell } from './AdminShell'
import { SignIn } from './SignIn'
import { SetPassword } from './SetPassword'
import { Dashboard } from './pages/Dashboard'
import { Companies } from './pages/Companies'
import { Funds } from './pages/Funds'
import { EntityDetail } from './pages/EntityDetail'
import { Cycles } from './pages/Cycles'
import { Submissions } from './pages/Submissions'
import { SubmissionDetail } from './pages/SubmissionDetail'
import { Reports } from './pages/Reports'
import { Settings } from './pages/Settings'

export default function AdminApp() {
  const [admin, setAdmin] = useState<AdminUser | null>(null)
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    get<{ admin: AdminUser }>('/auth/me')
      .then((res) => setAdmin(res.admin))
      .catch(() => setAdmin(null))
      .finally(() => setChecking(false))
  }, [])

  // Invitation and reset links must work while signed out.
  const credentialRoutes = (
    <Routes>
      <Route path="invite/:token" element={<SetPassword mode="invite" onSignedIn={setAdmin} />} />
      <Route path="reset/:token" element={<SetPassword mode="reset" onSignedIn={setAdmin} />} />
      <Route path="*" element={<SignIn onSignedIn={setAdmin} />} />
    </Routes>
  )

  if (checking) {
    return <div className="h-full flex items-center justify-center font-mulish text-text-support" style={{ fontSize: 12 }}>Loading…</div>
  }
  if (!admin) return credentialRoutes

  return (
    <AdminShell admin={admin}>
      <Routes>
        <Route index element={<Dashboard admin={admin} />} />
        <Route path="companies" element={<Companies />} />
        <Route path="companies/:id" element={<EntityDetail admin={admin} kind="company" />} />
        <Route path="funds" element={<Funds />} />
        <Route path="funds/:id" element={<EntityDetail admin={admin} kind="fund" />} />
        <Route path="cycles" element={<Cycles />} />
        <Route path="submissions" element={<Submissions />} />
        <Route path="submissions/:id" element={<SubmissionDetail />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings admin={admin} />} />
        <Route path="invite/:token" element={<Navigate to="/admin" replace />} />
        <Route path="reset/:token" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminShell>
  )
}
